import api from '../../api';
import {
  organizationsAnalyticsUrl,
  superAdminDeviceAnalyticsUrl,
  alertsStatsUrl,
  versionDistributionUrl,
  userCountAndDetailsUrl,
  thirdPartyIntegrationStatsUrl
} from '../../config';
import { IDateRange, IDeviceAnalyticsResponse, IOrganizationsAnalyticsResponse, IUsersAnalyticsResponse, IVersionDistributionResponse } from './analytics.types';
import {
  buildAlertsRangeQuery,
  buildStandardRangeQuery,
} from './analyticsUtils';

export const getOrganizationsAnalyticsApi = async () => {
  const response = await api.get<IOrganizationsAnalyticsResponse>(organizationsAnalyticsUrl);
  return response.data;
};

export const getDeviceAnalyticsApi = async (dateRange: IDateRange) => {
  const deviceAnalyticsResponse = await api.get<IDeviceAnalyticsResponse>(
    `${superAdminDeviceAnalyticsUrl}?${buildStandardRangeQuery(dateRange)}`
  );
  return deviceAnalyticsResponse.data.data;
};

export const getAlertsAnalyticsApi = async (dateRange: IDateRange) => {
  const alertsAnalyticsResponse = await api.get(
    `${alertsStatsUrl}?${buildAlertsRangeQuery(dateRange)}`
  );
  return alertsAnalyticsResponse.data;
};

export const getIntegrationsAnalyticsApi = async () => {
  const integrationsAnalyticsResponse =
    await api.get(
      thirdPartyIntegrationStatsUrl
    );

  return integrationsAnalyticsResponse.data;
};

export const getVersionDistributionApi = async () => {
  const response = await api.get<IVersionDistributionResponse>(versionDistributionUrl);
  return response.data;
};

export const getUsersAnalyticsApi = async () => {
  const response = await api.get<IUsersAnalyticsResponse>(
    `${userCountAndDetailsUrl}`
  );
  return response.data;
};